/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/extensions */
import React, { Component } from 'react';
import { Fade } from 'react-awesome-reveal';

import Header from 'parts/Header';
import Footer from 'parts/Footer';
import Button from 'elements/Button';

import {
  ORG_NAME,
  ORG_ADDRESS_FULL,
  ORG_EMAIL,
  ORG_CHARTER_NUMBER,
  TAX_NOTICE,
} from '../constants';

const usesOfFunds = [
  {
    title: 'Materials',
    description: 'Paint, instruments, recording gear, and performance supplies for our youth artists.',
  },
  {
    title: 'Mentor support',
    description: 'Training, background checks, and recognition for the volunteers in our corner.',
  },
  {
    title: 'Space & programming',
    description: 'The operating costs of being there, every week, in the Mt. Pleasant Neighborhood.',
  },
  {
    title: 'Showcases',
    description: 'The moments our youth share their work with family, friends, and community.',
  },
];

export default class DonatePage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const donateMailto = `mailto:${ORG_EMAIL}?subject=${encodeURIComponent('Donation inquiry')}`;
    return (
      <>
        <Header />
        <main id="main">

        {/* Hero */}
        <section className="container mx-auto px-4 md:px-12 pt-12 pb-8 lg:pt-16">
          <Fade direction="up" triggerOnce>
            <p className="text-sm font-medium text-theme-purple uppercase tracking-wider mb-3 text-center">
              Support our work
            </p>
            <h1 className="text-4xl md:text-5xl lg:text-6xl text-theme-blue font-serif font-bold leading-tight mb-6 text-center">
              Help a young person redefine their future
            </h1>
            <p className="font-light text-lg text-gray-500 max-w-2xl mx-auto leading-relaxed text-center">
              Every gift keeps the studio doors open and the lights on for the next young person who walks in.
            </p>
          </Fade>
        </section>

        {/* Tax notice */}
        <section className="container mx-auto px-4 md:px-12 mb-12">
          <Fade direction="up" triggerOnce>
            <div
              className="max-w-3xl mx-auto rounded-2xl border border-theme-gold bg-theme-gold/10 px-6 py-5 text-sm md:text-base text-theme-blue"
              role="note"
            >
              <p className="font-semibold mb-1">Tax-exempt status notice</p>
              <p className="font-light leading-relaxed">{TAX_NOTICE}</p>
            </div>
          </Fade>
        </section>

        {/* Where your gift goes */}
        <section className="container mx-auto px-4 md:px-12 mb-16">
          <div className="max-w-4xl mx-auto">
            <Fade direction="up" triggerOnce>
              <h2 className="text-3xl text-theme-blue font-serif font-bold mb-8">Where your gift goes</h2>
            </Fade>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {usesOfFunds.map((item, index) => (
                <Fade key={item.title} direction="up" delay={index * 100} triggerOnce>
                  <div className="rounded-2xl bg-white shadow-md border border-light-theme-purple p-6 h-full">
                    <h3 className="text-xl text-theme-blue font-semibold mb-2">{item.title}</h3>
                    <p className="font-light text-gray-500 leading-relaxed">{item.description}</p>
                  </div>
                </Fade>
              ))}
            </div>
          </div>
        </section>

        {/* How to give */}
        <section className="container mx-auto px-4 md:px-12 pb-20">
          <div className="max-w-4xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8">
            <Fade direction="up" triggerOnce>
              <div className="rounded-2xl bg-white shadow-lg border border-light-theme-purple p-8">
                <h3 className="text-2xl text-theme-blue font-serif font-bold mb-3">By email</h3>
                <p className="font-light text-gray-500 mb-6">
                  Reach out and we will send mailing instructions, ACH details, or a check address.
                </p>
                <Button
                  href={donateMailto}
                  isExternal
                  type="link"
                  className="inline-flex items-center px-6 py-3 bg-theme-purple text-white font-medium rounded-xl hover:bg-dark-theme-purple transition-all duration-200 cursor-pointer"
                >
                  Email to donate
                </Button>
              </div>
            </Fade>

            <Fade direction="up" delay={150} triggerOnce>
              <div className="rounded-2xl bg-white shadow-lg border border-light-theme-purple p-8">
                <h3 className="text-2xl text-theme-blue font-serif font-bold mb-3">Mail a check</h3>
                <p className="font-light text-gray-500 mb-2">Make checks payable to:</p>
                <p className="text-theme-blue font-semibold mb-4">{ORG_NAME}</p>
                <p className="font-light text-gray-500">{ORG_ADDRESS_FULL}</p>
              </div>
            </Fade>
          </div>

          <Fade direction="up" delay={300} triggerOnce>
            <p className="text-center text-sm text-gray-500 mt-10 max-w-2xl mx-auto font-light">
              In-kind donations of art supplies, instruments, or studio equipment are welcome — please email first so we can confirm what we can use. Ohio Nonprofit Charter #{ORG_CHARTER_NUMBER}.
            </p>
          </Fade>
        </section>

        </main>
        <Footer />
      </>
    );
  }
}
